module.exports = __webpack_public_path__ + "images/54094513446b5e7056d4fd94b5e6b31d.png";